import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";
import { useEffect, useState } from "react";
import { resetPassword2 } from "../../utils/auth";

const VerifyResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showVerify, setShowVerify] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = parseInt(queryParams.get("token"), 10);
    const email = queryParams.get("email");
    const formData = { email, code: token };
    resetPassword2(formData)
      .then((response) => {
        setShowVerify(false);
        setTimeout(() => {
          navigate("/login");
        }, 4000);
      })
      .catch((error) => {
        setShowVerify(false);
        setError(error?.response?.data?.msg);
        setTimeout(() => {
          navigate("/register");
        }, 4000);
      });
  }, [location.search, navigate]);

  return (
    <>
      <Header />
      <div className="tab-main-flex reset">
        {showVerify ? (
          <div class="tab-main-flex-content">
            <h2
              style={{
                background:
                  "linear-gradient(90deg, #ED9C17 12.5%, #CD495B 100%)",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              Verifying ...
            </h2>
            <p>Please wait while we verify.</p>
          </div>
        ) : error ? (
          <h2
            style={{
              background: "linear-gradient(90deg, #ED9C17 12.5%, #CD495B 100%)",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            {error}
          </h2>
        ) : (
          <div className="tab-main-flex-content">
            <div className="success-message2">
              <h2
                style={{
                  background:
                    "linear-gradient(90deg, #ED9C17 12.5%, #CD495B 100%)",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                }}
              >
                Password reset successfully
              </h2>
            </div>
            <h4>
              Back to <a href="/">Home</a>
            </h4>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default VerifyResetPassword;
